// components/FormBuilder/ComponentTypes/Text/index.tsx

import React from 'react';
import { Card, Input, Space } from 'antd';
import { DeleteOutlined, UpOutlined, DownOutlined, DragOutlined, UploadOutlined } from '@ant-design/icons';
import FeatherIcon from 'feather-icons-react';
import { SortableHandle } from 'react-sortable-hoc';
import { Typography } from 'antd';
import { Upload } from 'antd';
import { Button } from '../../../../../components/buttons/buttons';
import { useNotification } from '../../../../../context/notification.context';
const DragHandle = SortableHandle(() => <DragOutlined style={{ cursor: 'move' }} size={18} />);

export const Image = ({ component, onChange, onDelete }) => {
    const [collapsed, setCollapsed] = React.useState(false);
    const [base64Image, setBase64Image] = React.useState(component.src ? `data:image/png;base64,${component.src}` : null);
    const { notifyError, notifySuccess, notifyWarning } = useNotification();
    return (
        <Card
            size="small"
            draggable
            title={
                <Space direction="horizontal" align="center">
                    <DragHandle />
                    <Typography.Paragraph>Image</Typography.Paragraph>
                    <Typography.Paragraph disabled type="secondary">
                        (Media)
                    </Typography.Paragraph>
                </Space>
            }
            extra={
                <Space direction="horizontal">
                    <Button icon={<DeleteOutlined />} onClick={() => onDelete(component.id)} type="text" danger />
                </Space>
            }
        >
            {!collapsed && (
                <Space direction="vertical" style={{ width: '100%' }}>
                    {base64Image && (
                        <>
                            <img
                                src={base64Image}
                                alt="uploaded image"
                                style={{
                                    // minHeight: '200px',
                                    width: '100%',
                                    height: component.height ? `${component.height}px`: 'auto',
                                    objectFit: 'contain',
                                }}
                            />
                            <br />
                        </>
                    )}
                    <Upload
                        beforeUpload={(file) => {
                            const reader = new FileReader();
                            // console.log('file', file);
                            const sizeInKb = file.size / 1024;
                            if (sizeInKb > 300) {
                                notifyWarning({
                                    message: 'File size too large, please upload a file less than 300kb',
                                });
                                return false;
                            }
                            reader.onload = (e) => {
                                setBase64Image(e.target.result);
                                onChange({ ...component, src: e.target.result });
                            };
                            reader.readAsDataURL(file);
                            return false;
                        }}
                        showUploadList={false}
                        accept="image/jpeg,image/png,image/jpg"
                    >
                        <Button type="primary" icon={<FeatherIcon icon="upload" />}>
                            {base64Image ? 'Change Image' : 'Upload Image'}
                        </Button>
                        {!base64Image && (
                            <>
                                <br />
                                <br />
                                <p>Maximum file size: 300kb </p>
                                <p>Acceptable formats: JPEG, PNG</p>
                            </>
                        )}
                    </Upload>

                    <Input
                        type="number"
                        
                        value={component['height']}
                        onChange={(e) => onChange({ ...component, height:
                            parseInt(e.target.value)
                        })}
                        placeholder="Height"
                    />
                </Space>
            )}
        </Card>
    );
};
